import { render, staticRenderFns } from "./HomeStandingsIcon.vue?vue&type=template&id=6931a7ee&scoped=true"
import script from "./HomeStandingsIcon.vue?vue&type=script&lang=ts"
export * from "./HomeStandingsIcon.vue?vue&type=script&lang=ts"
import style0 from "./HomeStandingsIcon.vue?vue&type=style&index=0&id=6931a7ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6931a7ee",
  null
  
)

export default component.exports